import styled, { css } from 'styled-components';
import ArrowLink from 'Elements/Link/Arrow';

export const Container = styled.article`
    ${({ theme }) => css`
        margin: 0 0 1.5rem 0;
        display: flex;
        padding: 0.78rem;
        border-radius: 0.44rem;
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[2].hex};

        @media ${theme.breakpoints.medium.media} {
            display: grid;
            padding: 0.78rem 1.5rem;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        }
    `}
`;

export const DataContainer = styled.div`
    width: 100%;
`;

export const LinkWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
`;

export const Data = styled.div`
    ${({ theme }) => css`
        :first-of-type {
            font-weight: bold;
        }

        :nth-child(2) {
            font-weight: bold;
            font-size: 1.25rem;
        }

        @media ${theme.breakpoints.medium.media} {
            display: flex;
            align-items: center;

            :first-of-type {
                font-weight: normal;
            }

            :not(:first-of-type) {
                padding: 0 1rem;
                border-left: 0.06rem solid ${theme.colors.secondary.tints[2].hex};
            }
            :nth-child(2) {
                font-weight: normal;
                font-size: inherit;
            }
        }
    `}
`;

export const BookLink = styled(ArrowLink)`
    ${({ theme }) => css`
        font-weight: bold;
        white-space: nowrap;

        @media ${theme.breakpoints.medium.media} {
            padding-left: 1rem;
            border-left: 0.06rem solid lightgrey;
        }
    `}
`;

export const Icon = styled.svg`
    width: 0.88rem;
    margin-right: 0.5rem;
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.text.hex};

    ${Data} {
        font-weight: normal;
    }
`;
